import { Component, OnInit, inject } from '@angular/core';
import { CommonApiService } from '@core/services/common-api.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit {
  private api = inject(CommonApiService);
  private toastr = inject(ToastrService);

  ngOnInit(): void {
    const userId = Number(localStorage.getItem('userId'));
    this.api.allPostMethod('AccountSwitchAToB/GetToken', { userId }, true).subscribe({
      next: (res: any) => {
        if (!res['error'] && res['data']?.['abToken']) {
          const url = `${environment.blazzerUrl}/verify-token?ABToken=${encodeURIComponent(res['data']['abToken'])}&ReturnUrl=${encodeURIComponent('/home')}`;
          window.location.href = url;
          return;
        }
        this.toastr.error(res?.message || 'Something went wrong!!');
      },
      error: (error) => {
        this.toastr.error(error?.message || 'Something went wrong!!');
      }
    });
  }
}
